var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / DM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E02C42",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D22036",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-DM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#108753",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#108753",
    mask: "url(#mask-2)",
    x: 0,
    y: 12,
    width: 28,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L16,8 L28,8 L28,12 L16,12 L16,20 L12,20 L12,12 L0,12 L0,8 L12,8 L12,0 L16,0 Z",
    id: "Rectangle-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,0 L14.666,9.333 L28,9.33333333 L28,10.6666667 L14.666,10.666 L14.6666667,20 L13.3333333,20 L13.333,10.666 L0,10.6666667 L0,9.33333333 L13.333,9.333 L13.3333333,0 L14.6666667,0 Z",
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,0 L13.333,8 L28,8 L28,9.33333333 L13.333,9.333 L13.3333333,20 L12,20 L12,9.333 L0,9.33333333 L0,8 L12,8 L12,0 L13.3333333,0 Z",
    id: "Rectangle-2",
    fill: "#FCD449",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-83",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 10,
    r: 4.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,13.3333333 C15.8409492,13.3333333 17.3333333,11.8409492 17.3333333,10 C17.3333333,8.15905083 15.8409492,6.66666667 14,6.66666667 C12.1590508,6.66666667 10.6666667,8.15905083 10.6666667,10 C10.6666667,11.8409492 12.1590508,13.3333333 14,13.3333333 Z",
    id: "Oval-73",
    stroke: "#0E673F",
    strokeWidth: 1.33333333,
    strokeLinecap: "round",
    strokeDasharray: "0.6666666666666666,2.666666666666667",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,11.3333333 C14.7363797,11.3333333 14.6666667,10.7363797 14.6666667,10 C14.6666667,9.26362033 14.7363797,8.66666667 14,8.66666667 C13.2636203,8.66666667 13.3333333,9.26362033 13.3333333,10 C13.3333333,10.7363797 13.2636203,11.3333333 14,11.3333333 Z",
    id: "Oval-84",
    fill: "#0E673F",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/DM.0a4cc0f92129cd69ac75af8b7a315bc8.svg";
export { ForwardRef as ReactComponent };